<div>
  <div class="title text-primary  bg-white p-4">
    Bienvenue {{ user?.name }}!
  </div>

  <div class="px-3 ">

    <div class="card-container p-4 mt-3">
      <div class="fs-13 fw-5 mb-2">VUE GLOBALE</div>
      @if (!loadingStat) {
        <div class="d-flex gap-2 justify-content-between ">
          @for (item of statsArray;track item.id) {
            <div class="d-flex justify-content-between action-container align-items-center w-100">
              <div>
                <div class="fs-32">{{ item.value }}</div>
                <div class="fs-11">{{ item.label }}</div>
              </div>
              <svg-icon src="assets/icons/{{item.icon}}.svg"></svg-icon>
            </div>
          }
        </div>
      } @else {
        <div class="row">
          @for (item of statsArray;track item.id) {
            <div class="col-4">
              <ngx-skeleton-loader count="1" animation="progress" [theme]="{height: '86px'}"/>
            </div>
          }
        </div>
      }
    </div>


    <div class="d-flex justify-content-between gap-3 mt-3">
      <div class="card-container w-100">
        <div class="d-flex justify-content-between align-items-center header p-px-16">
          <div class="text-header">Missions à valider</div>
          <app-button text="Voir tout" color="accent" innerClass="cloud"
                      [routerLink]="['/dashboard/missions']"></app-button>
        </div>
        <div class="max-h-px-315 p-px-16 overflow-auto">
          @for (item of weekMissions;track item.id;let i = $index) {
            <div class="pb-px-14" (click)="handleRowClick(item)">
              <div class="card-container p-px-16">
                <div class="d-flex justify-content-between">
                  <div class="d-flex gap-1 align-items-center fw-7 fs-11">
                    <svg-icon src="assets/icons/building-black.svg"></svg-icon>
                    <div>{{ item.adresseDto?.name }}</div>
                  </div>
                  <app-tag [label]="item.missionStatus | statusMission" [type]="item.missionStatus"></app-tag>
                </div>
                <div class="text-secondary fs-13">Service d'affectation:
                  {{ item?.serviceAffectationsName }}
                </div>
                <div class="title-container">

                  <div class="fs-16 mt-px-8">{{ item.missionTitle }}</div>
                  <app-tag *ngIf="item?.isurgent" label="URGENT" [type]="3" class="fit-content col-4"
                           style="margin-top: 5px;" customIcon="red-flag"></app-tag>
                </div>
                <div class="text-secondary fs-13" style="margin-top: 5px;">Poste: {{ item?.typePoste }}</div>
                <div class="text-secondary fs-13">Du {{ item?.startdate | date: 'dd-MM-yyyy' }} au {{
                    item?.enddate | date:
                      'dd-MM-yyyy'
                  }}
                </div>


              </div>
            </div>
          } @empty {
            <div class="text-center d-flex flex-column justify-content-center h-100 ">
              <svg-icon src="assets/icons/check-primary.svg"></svg-icon>
              <div class="fw-7 fs-16 mt-px-24 mb-px-8">Vous êtes à jour</div>
              <div class="fw-3 fs-13 text-neutral-dark-grey">Vous n’avez aucune mission en attente de validation</div>
            </div>
          }


        </div>
      </div>

      <div class="card-container w-100">
        <div class="d-flex justify-content-between align-items-center header p-px-16">
          <div class="text-header">Contrats en attente de signature</div>
          <app-button text="Voir tout" color="accent" innerClass="cloud"
                      [routerLink]="['/dashboard/candidatures']"></app-button>
        </div>
        <div class="max-h-px-315 overflow-auto p-px-16" *ngIf="!loadingContract">
          @for (item of contratList;track item) {
            <div class="card-container p-px-16 mt-px-6">
              <div class="d-flex justify-content-between cursor-pointer align-items-center"
                   (click)="openMissionDetails(item)">
                <app-user [text]="item.candidateName" [imageSrc]="item.candidatePhoto"></app-user>
                <svg-icon src="assets/icons/chevron-right.svg"></svg-icon>
              </div>
              <div class="card-container p-px-16 mt-1">
                <div class="d-flex justify-content-between">
                  <div class="d-flex gap-1 align-items-center fw-7 fs-11">
                    <svg-icon src="assets/icons/building-black.svg"></svg-icon>
                    <div>{{ item.adresseDto?.name }}</div>
                  </div>
                </div>
                <div class="text-secondary fs-13" style="margin-top: 5px;"><span class="fs-11 fw-7 text-black">Service
                  d'affectation: </span>
                  {{ item?.serviceAffectationsName }}
                </div>
                <div class="title-container">
                  <div class="fs-16 mt-px-8">{{ item.missionTitle }}</div>
                  <app-tag *ngIf="item?.isurgent" label="URGENT" [type]="3" class="fit-content col-4"
                           style="margin-top: 5px;" customIcon="red-flag"></app-tag>
                </div>
                <div class="text-secondary fs-13" style="margin-top: 5px;"><span class="fs-11 fw-7 text-black">Poste:
                  </span>{{ item?.typePoste }}
                </div>
                <div class="text-secondary fs-13">Du {{ item?.startdate | date: 'dd-MM-yyyy' }} au {{
                    item?.enddate | date:
                      'dd-MM-yyyy'
                  }}
                </div>
              </div>
              <hr>
              <div class="d-flex justify-content-between">
                <div class="d-flex">
                  <svg-icon src="assets/icons/stethoscope-black.svg"></svg-icon>
                  <div class="ms-1 fs-16 ">{{ item.missionTitle }}</div>
                </div>
                <app-button [srcIcon]="'assets/icons/signature.svg'" [loading]="acceptLoading"
                            (handleClick)="generateContract(item)" text="Visualiser le contrat"></app-button>
              </div>
            </div>
          } @empty {
            <div class="text-center d-flex flex-column justify-content-center h-100 ">
              <svg-icon src="assets/icons/check-primary.svg"></svg-icon>
              <div class="fw-7 fs-16 mt-px-24 mb-px-8">Vous êtes à jour</div>
              <div class="fw-3 fs-13 text-neutral-dark-grey">Vous n’avez aucun contrat en attente de signature</div>
            </div>
          }

        </div>
        <app-loader *ngIf="loadingContract"></app-loader>
      </div>
    </div>

    <div class="d-flex justify-content-between gap-3 mt-3">

      <div class="card-container w-100">
        <div class="d-flex justify-content-between align-items-center header p-px-16">
          <div class="text-header">Nouvelles candidatures</div>
          <app-button text="Voir tout" color="accent" innerClass="cloud"
                      [routerLink]="['/dashboard/candidatures']"></app-button>
        </div>
        <div class="max-h-px-315 overflow-auto p-px-16">

          <div *ngIf="!candidatureLoading" class=" h-100">
            @for (item of candidatureList;track $index) {
              <div class="card-container p-px-16 mt-px-16">
                <div class="d-flex justify-content-between align-items-center" (click)="handleFullRowClick(item)">
                  <app-user [text]="item.candidature.candidateName"
                            [imageSrc]="item.candidature.candidatePhoto"></app-user>
                  <svg-icon src="assets/icons/chevron-right.svg" class="cursor-pointer"></svg-icon>
                </div>
                <div class="card-container p-px-16 mt-1">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex gap-1 align-items-center fw-7 fs-11">
                      <svg-icon src="assets/icons/building-black.svg"></svg-icon>
                      <div>{{ item.site }}</div>
                    </div>
                  </div>
                  <div class="text-secondary fs-13" style="margin-top: 5px;"><span class="fs-11 fw-7 text-black">Service
                    d'affectation: </span>
                    {{ item?.serviceAffectationsName }}
                  </div>
                  <div class="title-container">
                    <div class="fs-16 mt-px-8">{{ item.missionTitle }}</div>
                    <app-tag *ngIf="item?.isurgent" label="URGENT" [type]="3" class="fit-content col-4"
                             style="margin-top: 5px;" customIcon="red-flag"></app-tag>
                  </div>
                  <div class="text-secondary fs-13" style="margin-top: 5px;"><span class="fs-11 fw-7 text-black">Poste:
                  </span>{{ item?.typePoste }}
                  </div>
                  <div class="text-secondary fs-13">Du {{ item?.startdate | date: 'dd-MM-yyyy' }} au {{
                      item?.enddate | date:
                        'dd-MM-yyyy'
                    }}
                  </div>

                </div>
                <hr>
              </div>
            } @empty {
              <div class="text-center d-flex flex-column justify-content-center h-100 ">
                <svg-icon src="assets/icons/check-primary.svg"></svg-icon>
                <div class="fw-7 fs-16 mt-px-24 mb-px-8">Vous êtes à jour</div>
                <div class="fw-3 fs-13 text-neutral-dark-grey">Vous n’avez aucune candidature</div>
              </div>
            }
          </div>
          <app-loader *ngIf="candidatureLoading"></app-loader>
        </div>
      </div>

      <div class="card-container w-100">
        <div class="d-flex justify-content-between align-items-center header p-px-16">
          <div class="text-header">Cette semaine</div>
          <app-button text="Voir tout" color="accent" innerClass="cloud"
                      [routerLink]="['/dashboard/missions']"></app-button>
        </div>
        <div class="max-h-px-315 p-px-16 overflow-auto">
          @for (item of weekMissions;track item.id;let i = $index) {
            <div class="pb-px-14" (click)="handleRowClick(item)">
              <div class="card-container p-px-16">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <div class="d-flex gap-1 align-items-center fw-7 fs-11">
                      <svg-icon src="assets/icons/building-black.svg"></svg-icon>
                      <div>{{ item.adresseDto?.name }}</div>
                    </div>
                    <div class="text-secondary fs-13" style="margin-top: 5px;">Service d'affectation:
                      {{ item?.serviceAffectationsName }}
                    </div>
                  </div>
                  <app-tag [label]="item.missionStatus | statusMission" [type]="item.missionStatus"></app-tag>
                </div>
                <div class="title-container">
                  <div>{{ item.missionTitle }}</div>
                  <app-tag *ngIf="item?.isurgent" label="URGENT" [type]="3" class="fit-content col-4"
                           style="margin-top: 5px;" customIcon="red-flag"></app-tag>
                </div>


                <div class="text-secondary fs-13" style="margin-top: 5px;">Poste: {{ item?.typePoste }}</div>
                <div class="text-secondary fs-13">Du {{ item?.startdate | date: 'dd-MM-yyyy' }} au {{
                    item?.enddate | date:
                      'dd-MM-yyyy'
                  }}
                </div>

              </div>
            </div>
          } @empty {
            <div class="text-center d-flex flex-column justify-content-center h-100 ">
              <svg-icon src="assets/icons/check-primary.svg"></svg-icon>
              <div class="fw-7 fs-16 mt-px-24 mb-px-8">Rien de prévu</div>
              <div class="fw-3 fs-13 text-neutral-dark-grey">Vous n’avez aucune mission cette semaine</div>
            </div>
          }

        </div>
      </div>
    </div>


  </div>
</div>
